const $ = require('jquery');

const defaultController = 'shop';
const defaultAction = 'home';
const hashPrefix = '#!';

/**
 * Provides access to the different parts of URLs, paving over
 * @class
 * @param {String} url
 */
function UrlInfo(url) {
    this.url = url;
    this._a = window.document.createElement('a');
    this._a.href = url;
}

UrlInfo.prototype._getWindowProtocol = function () {
    return window.location.protocol;
};

UrlInfo.prototype._getWindowHost = function () {
    return window.location.host;
};

UrlInfo.prototype.href = function () {
    return this._a.href;
};

UrlInfo.prototype.origin = function () {
    if ('origin' in this._a) {
        return this._a.origin;
    }

    return `${this.protocol()}//${this.host()}`;
};

UrlInfo.prototype.protocol = function (protocol) {
    if (protocol) {
        this._a.protocol = `${protocol}:`;
    }

    return this._a.protocol ? this._a.protocol : this._getWindowProtocol();
};

UrlInfo.prototype.host = function () {
    if (!this._a.host) {
        return this._getWindowHost();
    }

    // IE returns default port in |host|
    const re = { 'http:': /:80$/, 'https:': /:443$/, 'ftp:': /:21$/ }[this._a.protocol];
    return re ? this._a.host.replace(re, '') : this._a.host;
};

UrlInfo.prototype.hostname = function () {
    return this._a.hostname;
};

UrlInfo.prototype.port = function () {
    return this._a.port;
};

UrlInfo.prototype.pathname = function (pathname) {
    if (pathname !== undefined) {
        this._a.pathname = pathname;
    }

    // IE does not include leading '/' in |pathname|
    if (this._a.pathname.charAt(0) !== '/') {
        return `/${this._a.pathname}`;
    }

    return this._a.pathname;
};

// Returns the search part as an Object
UrlInfo.prototype.getSearchObject = function () {
    try {
        return JSON.parse(`{"${decodeURI(this._a.search)
            .replace('&amp;', '&')
            .replace('?', '')
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')}"}`);
    } catch (e) {
        return {};
    }
};

UrlInfo.prototype.search = function (search, replace) {
    if (search !== undefined) {
        if (typeof search !== 'object') {
            // prevents breaking any old call of this method
            this._a.search = search;
        } else {
            this._a.search = replace
                ? $.param(search)
                : $.param($.extend(this.getSearchObject(), search));
        }
    }

    return this._a.search;
};

UrlInfo.prototype.hash = function () {
    return this._a.hash;
};

/* Custom url information */
function getPathComponent(index, defaultValue) {
    let pathname = this.pathname();
    const url = this.href();
    if (url.indexOf(hashPrefix) > 0) {
        const indexOfHashUrl = url.indexOf(hashPrefix) + hashPrefix.length;
        pathname = decodeURIComponent(url.slice(indexOfHashUrl, url.length));
    }
    const pathComponents = pathname.split('/');
    return pathname === '/' || pathComponents.length < index + 1
        ? defaultValue
        : pathComponents[index].toLowerCase();
}

UrlInfo.prototype.controller = function () {
    return getPathComponent.call(this, 1, defaultController);
};

UrlInfo.prototype.action = function () {
    return getPathComponent.call(this, 2, defaultAction);
};

UrlInfo.prototype.pathAndSearch = function () {
    return this.pathname() + this.search();
};

module.exports = UrlInfo;



// WEBPACK FOOTER //
// ./src/olycommon/urlinfo/url-info.js